import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import BrandLogo from '../common/BrandLogo';

export const SECTION_TABS = [
  { id: 'intro', label: '강의 소개' },
  { id: 'curriculum', label: '커리큘럼' },
  { id: 'pricing', label: '수강료' },
  { id: 'reviews', label: '합격 후기' },
  { id: 'faq', label: '자주 묻는 질문' },
];

const Header = ({ links = [], activeId }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const hashHref = (id) => (pathname === '/' ? `#${id}` : `/#${id}`);

  return (
    <Container>
      <Toolbar>
        <Logo type="button" onClick={() => navigate('/')} aria-label="패스로 홈">
          <BrandLogo height={32} />
        </Logo>
        <Nav aria-label="페이지 섹션">
          {links.map((link) => (
            <NavLink key={link.id} href={hashHref(link.id)} $active={activeId === link.id}>
              {link.label}
            </NavLink>
          ))}
        </Nav>
        <Actions>
          <TextButton type="button" onClick={() => navigate('/login')}>
            로그인
          </TextButton>
          <SolidButton type="button" onClick={() => navigate('/register')}>
            무료 첨삭 체험
          </SolidButton>
        </Actions>
      </Toolbar>
      {links.length > 0 && (
        <MobileNav aria-label="페이지 섹션">
          {links.map((link) => (
            <NavLink key={link.id} href={hashHref(link.id)} $active={activeId === link.id}>
              {link.label}
            </NavLink>
          ))}
        </MobileNav>
      )}
    </Container>
  );
};

export default Header;

const Container = styled.header`
  position: sticky;
  top: 0;
  z-index: 1000;
  flex-shrink: 0;
  background: rgba(248, 245, 238, 0.96);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #e7e1d3;
`;

const Toolbar = styled.div`
  max-width: 1120px;
  height: 64px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 28px;
`;

const Logo = styled.button`
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

const Nav = styled.nav`
  display: flex;
  gap: 4px;

  @media (max-width: 860px) {
    display: none;
  }
`;

const MobileNav = styled.nav`
  display: none;
  gap: 4px;
  padding: 0 12px;
  overflow-x: auto;
  scrollbar-width: none;
  border-top: 1px solid #e7e1d3;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 860px) {
    display: flex;
  }
`;

const NavLink = styled.a`
  flex-shrink: 0;
  position: relative;
  padding: 10px 10px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.02em;
  text-decoration: none;
  color: ${({ $active }) => ($active ? '#1d2340' : '#7a7464')};

  &::after {
    content: '';
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 4px;
    height: 7px;
    background: #ffe58a;
    z-index: -1;
    opacity: ${({ $active }) => ($active ? 1 : 0)};
  }

  &:hover {
    color: #1d2340;
    text-decoration: none;
  }
`;

const Actions = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const TextButton = styled.button`
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #1d2340;
  background: none;
  border: none;
  cursor: pointer;
`;

const SolidButton = styled.button`
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #fff;
  background: #1d2340;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: #2c3561;
  }

  @media (max-width: 420px) {
    padding: 9px 10px;
    font-size: 13px;
  }
`;
